import Icon from './Icon'

export default Icon



// WEBPACK FOOTER //
// ./src/components/icon/index.js